import { observer } from "mobx-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Colors, LOGO2 } from "../../assets";
import { PlaceItemInterface } from "../../interfaces_and_types";
import "./styles.css";
import { Checkbox } from "@mui/material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import { useRootStore } from "../../stores";

const PlaceItem = (props: PlaceItemInterface) => {
  const { t } = useTranslation();
  const { updateItemAvailable, updateItemPrice } =
    useRootStore().rootStore.placeStore;
  const [price, setPrice] = useState(props.item.price);

  return (
    <div className="place-item">
      <div className="place-item-image-wrapper">
        <img
          src={props.item.image !== null ? props.item.image : LOGO2}
          alt=""
          className={
            props.item.image !== null ? "place-item-image" : "place-item-image2"
          }
        />
      </div>
      <div className="place-item-details">
        <h3 className="place-item-title">{t(props.item.title)}</h3>
        <p className="place-item-price">{props.item.price} ₪</p>
      </div>
      <footer className="place-item-footer">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "90%",
          }}
        >
          <p className="place-item-available">{t("Available")}</p>
          <Checkbox
            icon={
              <RadioButtonUnchecked
                className="UncheckedCircle"
                style={{ color: Colors.GREEN }}
              />
            }
            checkedIcon={<CheckCircle className="CheckCircle" />}
            style={{
              height: 20,
              width: 20,
            }}
            onClick={() =>
              updateItemAvailable(!props.item.isAvailable, props.item)
            }
            checked={props.item.isAvailable}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "90%",
          }}
        >
          <p className="place-item-available">{t("Price")}</p>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p style={{ color: Colors.GREEN, fontWeight: "bold" }}> ₪</p>
            <input
              type="number"
              step={"0.1"}
              value={price}
              style={{ width: "40px", marginRight: "5px" }}
              onChange={(e) => setPrice(parseFloat(e.currentTarget.value))}
            />
            <input
              type="submit"
              value="✓"
              style={{
                width: "30px",
                marginRight: "5px",
                color: Colors.LIGHTERPURPLE,
                fontWeight: "bold",
              }}
              onClick={(e) => {
                e.preventDefault();
                //console.log(price);
                price !== props.item.price &&
                  updateItemPrice(price, props.item);
              }}
            />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default observer(PlaceItem);
